import { supabase } from "@/integrations/supabase/client";

export type SignupSource =
  | "home"
  | "journal-cta"
  | "footer"
  | "7-signs-optin"
  | "other";

export type SignupEvent =
  | "newsletter_signup_attempt"
  | "newsletter_signup_success"
  | "newsletter_signup_error";

/**
 * Logs a newsletter signup conversion event to email_analytics.
 * Fire-and-forget — never blocks the form submission.
 *
 * @param event         Stage of the funnel.
 * @param source        Where the form lives on the site (attribution).
 * @param email         Recipient email if we have it (otherwise "anonymous").
 * @param subscriberId  Newsletter subscriber id when known.
 */
export const trackSignup = (
  event: SignupEvent,
  source: SignupSource,
  _email?: string | null,
  subscriberId?: string | null,
) => {
  void supabase.functions.invoke("track-event", {
    body: {
      kind: "analytics",
      event_type: event,
      campaign_type: "newsletter_signup",
      campaign_id: source,
      event_data: {
        source,
        subscriber_id: subscriberId ?? null,
        path:
          typeof window !== "undefined" ? window.location.pathname : null,
        referrer:
          typeof document !== "undefined" ? document.referrer : null,
        user_agent:
          typeof navigator !== "undefined" ? navigator.userAgent : null,
      },
    },
  })
    .then(({ error }) => {
      if (error) console.error("trackSignup failed", error);
    });
};